import React from 'react';
import gql from 'graphql-tag';
import {
  MyAccountCreditCardListFields,
} from '../schemas/rql';
import MyAccountCreditCardEditForm, { MyAccountCreditCardEditFormFragment } from './MyAccountCreditCardEditForm';

type CreditCard = MyAccountCreditCardListFields.CreditCards;

interface Props {
  creditCards: CreditCard[];
}

export default function MyAccountCreditCardList({ creditCards }: Props) {
  return (
    <ul>
      {creditCards.map((creditCard) => (
        <li key={creditCard.id}>
          <div className="padding-2 mb-1 bd-1 bd-rounded bd--light-gray">
            <MyAccountCreditCardEditForm creditCard={creditCard} />
          </div>
        </li>
      ))}
    </ul>
  );
}

export const MyAccountCreditCardListFragment = gql`
  fragment MyAccountCreditCardListFields on rql_Me {
    creditCards {
      id
    }
    ...MyAccountCreditCardEditFormFields
  }
  ${MyAccountCreditCardEditFormFragment}
`;
